import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import Box from '../Box';
import * as constants from '../constants';
import _styles from './styles.module.css';

const PageSection = ({
  children,
  styles,
  size,
  profile,
  backgroundColor,
  fluid,
  className, // eslint-disable-line
  style, // eslint-disable-line
  ...props
}: any) => (
  <Box display="flex" justifyContent="center" style={{ backgroundColor }}>
    <Box
      className={cnames(
        styles.section,
        {
          [styles.small]: size === constants.SMALL,
          [styles.medium]: size === constants.MEDIUM,
          [styles.large]: size === constants.LARGE,
          [styles.desktop]: profile === constants.DESKTOP,
          [styles.mobile]: profile === constants.MOBILE,
          [styles.fluid]: fluid,
        },
      )}
      {...props}
    >
      { children }
    </Box>
  </Box>
);

(PageSection as any).displayName = 'PageSection';

(PageSection as any).propTypes = {
  /**
    * The children of the section.
    */
  children: PropTypes.node.isRequired,
  /**
    * The background color of the section
    */
  backgroundColor: PropTypes.string,
  /**
    * The CSS classNames for this component. NEVER manually specify this prop
    */
  styles: PropTypes.shape({}),
  /**
    * The maximum relative width of the centered content
    */
  size: PropTypes.oneOf([constants.SMALL, constants.MEDIUM, constants.LARGE]),
  /**
    * Pick a profile to set sensible defaults
    */
  profile: PropTypes.oneOf([constants.MOBILE, constants.DESKTOP]),
  /**
    * When true, the page section content stretches edge to edge
    */
  fluid: PropTypes.bool,
};

(PageSection as any).defaultProps = {
  styles: _styles,
  profile: constants.MOBILE,
  backgroundColor: 'transparent',
  size: constants.MEDIUM,
  fluid: false,
};

export default PageSection;
